import React from 'react';
import { SectionLabel } from './ui/SectionLabel';
import { TestimonialCard } from './TestimonialCard';
import type { Testimonio } from '../data/content';
type TestimonialsProps = {
  label: string;
  title: string;
  testimonios: Testimonio[];
};
export function Testimonials({
  label,
  title,
  testimonios
}: TestimonialsProps) {
  return <section className="w-full bg-ink px-5 py-16 sm:px-8 sm:py-20" data-id="element-174" data-mp="3b01fr9oa1qri">
      <div className="mx-auto max-w-6xl" data-id="element-175" data-mp="36z95qe7kzhu6">
        <div className="text-center" data-id="element-176" data-mp="370ag0ggrw0au">
          <SectionLabel data-id="element-177" data-mp="32063t2mwdrqf">{label}</SectionLabel>
          <h2 className="mt-4 font-display text-3xl font-extrabold text-white sm:text-4xl" data-id="element-178" data-mp="31ybg5gk8rlin">
            {title}
          </h2>
        </div>
        <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-179" data-mp="2s1qaqu4b88ea">
          {testimonios.map(testimonio => <li key={testimonio.name} data-id="element-180" data-mp="v9yfpaj1vt9q">
              <TestimonialCard testimonio={testimonio} data-id="element-181" data-mp="v8wvogk23wfv" />
            </li>)}
        </ul>
      </div>
    </section>;
}